import React from "react";
import { RuntimeReactContext } from "../context";
function wrapRuntimeContextProvider(App, contextValue) {
  return /* @__PURE__ */ React.createElement(RuntimeReactContext.Provider, {
    value: contextValue
  }, App);
}
export {
  wrapRuntimeContextProvider
};
